import { skeleton } from "@web/theme/theme";
import { Stack } from "./Stack";

export type SkeletonProps = { variant?: "rows" | "cards"; count?: number; className?: string };

/** Loading placeholder (skeletons, not spinners). */
export function Skeleton({ variant = "rows", count = 3, className = "" }: SkeletonProps) {
  return (
    <div aria-hidden className={className}>
      <Stack gap={variant === "rows" ? 2 : 3}>
        {Array.from({ length: count }, (_, i) => (
          <div key={i} className={variant === "rows" ? skeleton.row : skeleton.card} />
        ))}
      </Stack>
    </div>
  );
}
